// extracted by mini-css-extract-plugin
export default {"box":"SendMessageTab_box__UrFQV"};